const services = [
  {
    num: "01",
    title: "Deal Origination",
    desc: "We identify and acquire proprietary, off-market UK businesses — pursuing opportunities we own and build, aligned with our long-term value creation strategy.",
    tags: ["Off-Market Acquisition", "Due Diligence", "Valuation"],
  },
  {
    num: "02",
    title: "Capital Partnership (UK–MENA Focus)",
    desc: "We partner with international capital — particularly across the MENA region — to participate alongside us in carefully selected UK business acquisitions.",
    tags: ["MENA Capital Access", "UK Deal Flow", "Cross-Border Alignment"],
  },
  {
    num: "03",
    title: "Transaction Leadership",
    desc: "We structure and lead complex acquisitions — aligning capital partners, navigating jurisdictional frameworks, and advancing transactions with precision.",
    tags: ["Deal Architecture", "Jurisdictional Navigation", "Alignment of Interests"],
  },
  {
    num: "04",
    title: "Operator & Partner Network",
    desc: "We work with a select network of operators, sector specialists, and strategic partners to evaluate opportunities and support value creation post-acquisition.",
    tags: ["Operator Network", "Sector Expertise", "Post-Transaction Support"],
  },
  {
    num: "05",
    title: "Capital Partners",
    desc: "We work with a select group of capital partners who participate alongside us in proprietary acquisition opportunities.",
    tags: ["Curated Opportunities", "Aligned Interests", "Long-Term Partnerships"],
  },
  {
    num: "06",
    title: "Confidential Process",
    desc: "Every engagement is conducted with absolute discretion — ensuring complete confidentiality from initial approach through to transaction close.",
    tags: ["NDA Protocols", "Secure Communication", "Discreet Execution"],
  },
];

export default function ServicesSection() {
  return (
    <section id="services" className="w-full bg-[#0a0a0a] py-20 sm:py-28 px-5 sm:px-8 md:px-16">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-14 sm:mb-20">
          <p className="text-[#c9a84c] text-[10px] tracking-[5px] uppercase mb-4 sm:mb-5">How We Operate</p>
          <h2 className="text-white font-serif text-2xl sm:text-3xl md:text-5xl tracking-wide">
            Our Process
          </h2>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10">
          {services.map((s) => (
            <div
              key={s.num}
              className="bg-[#0a0a0a] p-6 sm:p-8 group hover:bg-[#111111] transition-colors duration-300 cursor-pointer"
            >
              <p className="text-[#c9a84c] text-xs tracking-[3px] font-mono mb-3 sm:mb-4 opacity-50">
                {s.num}
              </p>
              <h3 className="text-white text-xs sm:text-sm tracking-[2px] uppercase font-medium mb-2 sm:mb-3 group-hover:text-[#c9a84c] transition-colors duration-300 leading-relaxed">
                {s.title}
              </h3>
              <p className="text-white/45 text-sm leading-relaxed mb-4 sm:mb-5">{s.desc}</p>
              <div className="flex flex-wrap gap-2">
                {s.tags.map((tag) => (
                  <span
                    key={tag}
                    className="text-[10px] tracking-[1px] text-white/30 border border-white/10 px-2 py-1 uppercase"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12 sm:mt-16 px-4 sm:px-0">
          <a
            href="#contact"
            onClick={(e) => { e.preventDefault(); document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" }); }}
            className="inline-block w-full sm:w-auto px-8 sm:px-14 py-4 border border-[#c9a84c]/50 text-[#c9a84c] text-xs tracking-[3px] sm:tracking-[5px] uppercase hover:bg-[#c9a84c] hover:text-black transition-all duration-300 cursor-pointer whitespace-nowrap text-center"
          >
            DISCUSS YOUR MANDATE
          </a>
        </div>
      </div>
    </section>
  );
}
